import { render } from "./PhotoPatient.vue?vue&type=template&id=340fba86"
import script from "./PhotoPatient.vue?vue&type=script&lang=js"
export * from "./PhotoPatient.vue?vue&type=script&lang=js"

import "./PhotoPatient.vue?vue&type=style&index=0&id=340fba86&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__